import Vue from "vue";
import VueApollo from "vue-apollo";
import { createApolloClient } from "vue-cli-plugin-apollo/graphql-client";
import Cookies from "js-cookie";
Vue.use(VueApollo);

const AUTH_TOKEN = "apollo-token";

export const defaultOptions = {
	httpLinkOptions: {
		credentials: "include",
		headers: {
			"X-CSRFToken": Cookies.get("csrftoken"),
		},
	},
	// Use `null` to disable subscriptions
	wsEndpoint: null,
	// LocalStorage token
	tokenName: AUTH_TOKEN,
	// Enable Automatic Query persisting with Apollo Engine
	persisting: false,
	// Use websockets for everything (no HTTP)
	// You need to pass a `wsEndpoint` for this to work
	websocketsOnly: false,
	// Is being rendered on the server?
	ssr: false,
	// Override the way the Authorization header is set
	// getAuth: (tokenName) => ...

	// Additional ApolloClient options
	// apollo: { ... }

	// Client local data (see apollo-link-state)
	// clientState: { resolvers: { ... }, defaults: { ... } }
};

// Call this in the Vue app file
export function createProvider(environment, options = {}) {
	const { apolloClient } = createApolloClient({
		...defaultOptions,
		...options,
		httpEndpoint: new URL(
			environment.isExternal ? "/extgql" : "/graphql",
			environment.backendURL,
		).href,
	});

	const apolloProvider = new VueApollo({
		defaultClient: apolloClient,
	});

	return apolloProvider;
}
